import {MetaTagsProps, SubCategory} from "@/types";
import {content} from "./content";
import {images} from "./images";
import {BUSINESS_NAME, OG_PATH} from "@/content";

const serviceId = 2
const slug = 'basement-construction-sydney';
export const createMetaTags = (parentMetaTags: MetaTagsProps): { metaTags: MetaTagsProps; slug: string } => {

    const metaTags : MetaTagsProps =  {
        title: `Basement Construction Sydney | ${BUSINESS_NAME}`,
        description: "Complete excavation, formwork, and concreting for underground structures. Expert basement construction services in Sydney.",
        keywords: "basement construction sydney, underground structures, excavation services, formwork, concreting, foundation work, retaining walls, waterproofing, structural support, residential basements, commercial basements, custom basement design, construction project management, sydney builders",
        url: `${parentMetaTags.url}/${slug}`,
        ogImage: `${OG_PATH}c1-s${serviceId}.jpg`,
        type: "website",
    };

    return {metaTags, slug};
};

export const category: Omit<SubCategory, 'headCategory' | 'slug' | 'metaTags'> = {
    id: serviceId,
    title: 'Basement Construction Sydney',
    description: 'Complete excavation, formwork, and concreting for underground structures.',
    points: [
    ],
    images: images.map((image, index) => ({
        ...image,
        alt: `${slug}-${index + 1}`,
    })),
    content,
}
